export default __webpack_public_path__ + "static/database-design-2723d3173892239b6f2e18bae882b290.svg";